import '../../_helpers/sort-by.js'
export const listCreativeType = [
    {value:'NATIVE', label:'Native ad'},
    {value:'VIDEO', label:'Video ad'},
    {value:'DISPLAY_BANNER', label:'Image'},
    {value:'DISPLAY_AD_TAG', label:'Ad Tag'},
].sortBy('label')